<template>
  <div class="bg-white rounded-xl border border-gray-200 p-5">
    <div class="flex items-center gap-3 mb-3">
      <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" :class="iconBgClass">
        <i :class="'fa-solid fa-' + icon" class="text-sm" :style="'color:' + iconColor"></i>
      </div>
      <span class="text-xs font-medium text-gray-500 uppercase tracking-wide">{{ label }}</span>
    </div>

    <div class="text-xl font-bold text-gray-900 mb-2">
      {{ formattedValue }}
    </div>

    <div v-if="evolution != null" class="flex items-center gap-2">
      <span class="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full" :class="evolutionClasses">
        <i v-if="evolution > 0" class="fas fa-arrow-up text-[10px]"></i>
        <i v-else-if="evolution < 0" class="fas fa-arrow-down text-[10px]"></i>
        {{ formatEvolution(evolution) }}
      </span>
    </div>
  </div>
</template>

<script>
import { formatCurrency, formatInteger, formatEvolution } from './helpers'

export default {
  name: 'KpiCard',
  props: {
    label: String,
    value: [Number, String],
    evolution: Number,
    format: { type: String, default: 'integer' },
    icon: { type: String, default: 'chart-bar' },
    color: String
  },
  computed: {
    formattedValue() {
      if (this.format === 'currency') return formatCurrency(this.value)
      if (this.format === 'percent') return `${(this.value ?? 0).toFixed(1)}%`
      return formatInteger(this.value)
    },
    evolutionClasses() {
      if (this.evolution > 0) return 'bg-green-50 text-green-600'
      if (this.evolution < 0) return 'bg-red-50 text-red-600'
      return 'bg-gray-100 text-gray-500'
    },
    iconBgClass() {
      if (this.color) return ''
      return 'bg-primary-50'
    },
    iconColor() {
      return this.color || '#0D9488'
    }
  },
  methods: {
    formatEvolution
  }
}
</script>
